module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-275.31618c54.jpg";